<div fxLayout="row" fxLayoutAlign="start">
  <form [formGroup]="contactInfoFormGroup" >
    <div fxLayout="column">
      <div fxLayout="row">
        @if (alreadyActivated$ | async) {
          <alert
            fxFlex="75"
            alertType="warning"
            [message]="'WP-ChangeContactInfoAlreadyActivatedInformation' | translate"
          ></alert>
        }
      </div>
    </div>
    <div fxLayout="column">
      <div fxLayout="row" fxFlex="60">
        <mat-form-field appearance="outline" fxFlex="25">
          <mat-label>{{ 'PhoneCode' | translate }}</mat-label>
          <mat-select formControlName="phoneCodeId" required>
            @for (phoneCode of listOfPhoneCodes$ | async; track phoneCode) {
              <mat-option #matOption [value]="phoneCode.Id">{{ phoneCode.Prefix }}</mat-option>
            }
          </mat-select>
          @if (phoneCodeId.invalid && phoneCodeId.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="50">
          <mat-label>{{ 'PhoneNumber' | translate }}</mat-label>
          <input matInput #phoneNumberInput placeholder="{{ 'PhoneNumber' | translate }}" formControlName="phoneNumber" appNumbersOnly required />
          @if (phoneNumber.invalid && phoneNumber.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div fxLayout="column">
        <div fxLayout="row">
          <mat-form-field appearance="outline" fxFlex="75">
            <mat-label>{{ 'Email' | translate }}</mat-label>
            <input matInput type="email" placeholder="{{ 'Email' | translate }}" formControlName="email" required />
            @if (email.invalid && email.touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <button mat-raised-button color="primary" (click)="onSave()">{{ 'Save' | translate }}</button>
      <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
    </div>
  </form>
</div>
